var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg024Menu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 7H3C2.44772 7 2 6.55228 2 6C2 5.44772 2.44772 5 3 5H9C9.55228 5 10 5.44772 10 6C10 6.55228 9.55228 7 9 7ZM9 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H9C9.55228 11 10 11.4477 10 12C10 12.5523 9.55228 13 9 13ZM3 19H9C9.55228 19 10 18.5523 10 18C10 17.4477 9.55228 17 9 17H3C2.44772 17 2 17.4477 2 18C2 18.5523 2.44772 19 3 19ZM15 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H15C14.4477 13 14 12.5523 14 12C14 11.4477 14.4477 11 15 11ZM21 5H15C14.4477 5 14 5.44772 14 6C14 6.55228 14.4477 7 15 7H21C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5ZM15 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H15C14.4477 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg024Menu);
export default __webpack_public_path__ + "static/media/024-menu.9bc7df3df1cc628b01faadabb31083f7.svg";
export { ForwardRef as ReactComponent };